import * as React from 'react';
import { Helmet } from 'react-helmet-async';

export const PreloadImage: React.FC<{ href?: string | undefined }> = ({
  href,
}) => {
  if (href) {
    return (
      <Helmet>
        <link rel="preload" as="image" href={href} />
      </Helmet>
    );
  }
  return null;
};
